// extracted by mini-css-extract-plugin
module.exports = {"sidebarMenuItem":"SidebarMenuItem_sidebarMenuItem__3etEk","active":"SidebarMenuItem_active__3eG2E","sidebarMenuItemTextOnly":"SidebarMenuItem_sidebarMenuItemTextOnly__1NyYN"};